<template>
  <v-container>
    <v-layout>
      <div style="display: flex; align-items: center;">
        <img
          src="../assets/concord_cover.webp"
          style="border-radius: 20px; width: 45%;"
          class="hidden-md-and-down"
        />
        <v-flex
          class="align-content-center flex-wrap"
          style="justify-content: center; margin-left:15px"
        >
          <v-card
            class="primary"
            style="max-width: 100%; border-radius:  20px; text-align:center; padding:10px;"
          >
            <img
              src="../assets/Concord_Logo_Final.webp"
              style=" max-width: 80%; padding: 10px"
            />
            <div>
              <h2
                style=" color: white; font-size: 25px; font-family: 'Hind', sans-serif; padding: 10px; font-display: fallback;"
              >
                A Community Built by Individuals
              </h2>
              <h3
                style=" color: white; font-size: 18px; font-family: 'Hind', sans-serif; text-transform: capitalize; padding: 10px; font-display: fallback;"
              >
                Sign In to View Our Community's Content
              </h3>
            </div>

            <sign-in> </sign-in>
            <div style=" margin-top:10px">

                <span><a href="/passwordrecovery">Forgot Password?</a> </span><br>
              <span style="color:white; ">
                Don't Have An Account?
                <a href="/signup" style="color:white;">
                  Sign Up</a
                ></span
              >
            </div>
          </v-card>
        </v-flex>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import SignIn from "./SignIn.vue";

export default {
  data() {
    return {
      exampleDialog: false,
      items: [],
    };
  },
  components: {
    SignIn: SignIn,
  },
};
</script>

<style lang="scss">
@import "../assets/main.scss";
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;700&display=swap");
</style>
